import { Navigate, useLocation } from "react-router-dom";

export const UnknownRoute = ({ to }: { to: string }) => {
  const prevRoute = useLocation();
  return <Navigate to={to} state={{ prevRoute }} replace />;
};
